import { render, staticRenderFns } from "./PcCooperation.vue?vue&type=template&id=083434ba&"
import script from "./PcCooperation.vue?vue&type=script&lang=js&"
export * from "./PcCooperation.vue?vue&type=script&lang=js&"
import style0 from "./PcCooperation.vue?vue&type=style&index=0&id=083434ba&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports